<template>
<el-dialog
    v-drag
    :title="currentFolder.id==-1?'新增文件夹':'修改文件夹'"
    :visible.sync="dialogVisible"
    width="1200px"
    :show-close="true"
    :append-to-body="true"
    :destroy-on-close="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
    v-loading="loading">
  <div>
     <el-form ref="form" class="form" :model="form" :rules="rules" label-width="120px">
        <el-form-item prop="folderName" label="文件夹名称">
            <el-input v-model="form.folderName" style="width:520px"></el-input>
        </el-form-item>
        <el-form-item prop="folderRuleType" label="文件夹条件">
            <el-radio v-model="form.folderRuleType" label="0">满足所有条件</el-radio>
            <el-radio v-model="form.folderRuleType" label="1">满足任意一条</el-radio>
        </el-form-item>
        <div class="folderRuleList">
            <div  v-for="(item,index) in form.folderRuleList" :key="index">
                <el-form-item label-width="0" :prop="'folderRuleList.' + index + '.conditionFieldType'" :rules="rules.conditionFieldType">
                    <el-select style="width: 100%" v-model="item.conditionFieldType" placeholder="请选择">
                        <el-option label="主题" value="0"></el-option>
                        <el-option label="发件人" value="1"></el-option>
                        <el-option label="收件人" value="2"></el-option>
                        <el-option label="正文" value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label-width="0" :prop="'folderRuleList.' + index + '.conditionOperatorType'" :rules="rules.conditionOperatorType">
                    <el-select style="width: 100%" v-model="item.conditionOperatorType" placeholder="请选择">
                        <el-option label="包含" value="0"></el-option>
                        <el-option label="等于" value="1"></el-option>
                    </el-select>
                </el-form-item>
               <el-form-item label-width="0" :prop="'folderRuleList.' + index + '.conditionValue'" :rules="rules.conditionValue">
                    <el-input style="width: 100%" v-model="item.conditionValue" placeholder="请输入" />
                </el-form-item>
                <div>
                    <el-button size="small" @click="add" v-if="(index+1)==form.folderRuleList.length">
                        <i class="el-icon-circle-plus-outline" style="color:#2395f3;"></i>
                    </el-button>
                    <el-button size="small" @click="del(index)">
                        <i class="el-icon-remove-outline" style="color:red;"></i>
                    </el-button>
                </div>
            </div>
            <div class="init-rule" v-if="form.folderRuleList.length==0">
                <el-button size="small" @click="add"  icon="el-icon-circle-plus-outline" circle></el-button>
            </div>
        </div>
    </el-form>
  </div>
    <span slot="footer" class="footers">
        <div class="cancel flex_c_c" @click="cancel">取 消</div>
        <div class="ok flex_c_c" @click="ok('form')">确 定</div>
    </span>
</el-dialog>
</template>

<script>

import { addorUpdateFolder } from '@/api/email'
export default {
    props:{
        dialogVisible:{
            type:Boolean,
            default:false
        },
        currentFolder:{
            type:Object
        },
    },
    watch:{
        dialogVisible(val){
            if(val){
                console.log('watch',this.currentFolder);
                if(this.currentFolder.id!=-1){
                    this.form.folderName = this.currentFolder.folderName;
                    this.form.folderRuleType = this.currentFolder.folderRuleType.toString();

                    if(this.currentFolder.ruleList && this.currentFolder.ruleList.length>0){
                        this.form.folderRuleList = this.currentFolder.ruleList.map(x=>{
                            x.conditionFieldType=x.conditionFieldType.toString();
                            x.conditionOperatorType=x.conditionOperatorType.toString();
                            return x;
                        });
                    }
                }
                else{
                    this.form.folderName = '';
                    this.form.folderRuleType='0';
                    this.form.folderRuleList=[];
                }

                
                if(this.form.folderRuleList.length ==0){
                    this.form.folderRuleList.push({conditionFieldType:'0',conditionOperatorType:'0',conditionValue:''})
                }
            }
        }
    },
    data(){
        return {
            loading:false,
            form: {
                folderName: '',
                folderRuleType:'0',
                folderRuleList:[]
            },
            rules: {
                folderName: [{ required: true, message: '请输入文件夹名称', trigger: 'blur' }],
                folderRuleType: [{ required: true, message: '请选择条件类型', trigger: 'change' }],
                conditionFieldType: [{ required: true, message: '请选择条件字段', trigger: 'change' }],
                conditionOperatorType: [{ required: true, message: '请选择条件操作符', trigger: 'change' }],
                conditionValue: [{ required: true, message: '请输入条件值', trigger: 'blur' }],
            }
        };
    },
    methods:{
        cancel(){
            this.$emit('cancel')
        },
        ok(formName){
            this.$refs[formName].validate(async(valid) => {
                if (valid) {
                   console.log(this.form)
                   var params={
                    emailAccountId:this.currentFolder.emailAccountId,
                    id: this.currentFolder.id==-1?undefined:this.currentFolder.id,
                    folderName:this.form.folderName,
                    folderRuleType:this.form.folderRuleType,
                    rules:this.form.folderRuleList
                   }
                    this.loading = true;
                   await addorUpdateFolder(params).then(res=>{
                        if(res.success){
                            this.$emit('cancel');
                            this.$message.success('文件夹创建成功, 3S后自动刷新')
                             this.$nextTick(() => {
                                    setTimeout(() => {
                                    window.location.reload()
                                    }, 3000)
                                })
                        }else{
                            this.$message.error(res.errorMessage)
                        }
                        this.loading = false;
                   })

                }
            })
        },
        add(){
            this.form.folderRuleList.push({conditionFieldType:'0',conditionOperatorType:'0',conditionValue:''})
        },
        del(index){
            this.form.folderRuleList.splice(index,1);
        }
    }
}
</script>

<style  lang="less"  scoped>

.folderRuleList{
    box-shadow: 0 0 2px 2px #EEEEEE;
    padding: 15px;
    border-radius: 5px;
    margin: 20px;
    min-height: 220px;
    max-height: 350px;
    overflow: auto;
    position: relative;
    transition: 0.1s ease-in;

    >div{
        display: flex;
    }
    >div>div{
        margin-left: 10px;
        transition: 0.1s ease-in;
    }

    >div>div:last-child{
        margin-left: 30px;
    }
    
    >div>div:last-child i{
        font-size: 16px;
    }
}

.init-rule{
    position: absolute;
    right: 10px;
    top: 10px;
}

.footers {
  width: 100%;
  display: flex;
  justify-content: center;
  .cancel {
    width: 120px;
    height: 40px;
    background: #EEEEEE;
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    margin-right: 16px;
    cursor: pointer;
  }
  .ok {
    width: 120px;
    height: 40px;
    background:  rgb(18,88,188);
    border-radius: 4px 4px 4px 4px;
    font-size: 14px;
    cursor: pointer;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
}

</style>